export const PLAIN_JSON_TYPES = new Set(['Credit-Report', 'Paypal'])
